export default __webpack_public_path__ + "static/media/game-providers.915d6362.svg";